export default "__VITE_ASSET__lAYUlpKa__"